(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function initCollectionDescriptionToggle() {
    const description = document.querySelector('[class*="__text_twGGkJ"]');
    if (!description || description.dataset.toggleInit) return;
    description.dataset.toggleInit = 'true';

    requestAnimationFrame(() => {
      if (description.scrollHeight <= description.clientHeight + 2) return;

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'collection-description-toggle';
      toggle.textContent = 'Show more';
      description.insertAdjacentElement('afterend', toggle);

      toggle.addEventListener('click', () => {
        const expanded = description.classList.toggle('collection-description--expanded');
        toggle.textContent = expanded ? 'Show less' : 'Show more';
        if (!expanded) {
          description.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionDescriptionToggle);
  } else {
    initCollectionDescriptionToggle();
  }

  } catch(e) { console.error(e); }
})();
})();
